import { QueryRequestProvider } from '../../component/request'
import { QueryResponseProvider } from '../../component/response'
import { ComponentRequest } from '../../component/componentLayout'
import { ListViewProvider } from '../../component/view'
import { useParams } from 'react-router-dom'
import { getCustomerPurchaseList } from '../api'

const comRequest = {
    type: "user_ledger",
    label: "TXN No.",
    // createUserTypeButton: '/apps/company-management/user-type',
    // by_user_type_download: 'yes',
    // user_address_upload: 'yes',
    // uploadLink: '/apps/company-management/end_user/upload',
    // addLink: '/apps/company-management/end_user/create',
    // userMapping: '/apps/company-management/user_mapping'
}

/**
 * UserPurchaseWrapper
 * Provides context and API for user purchase list views.
 */
const UserPurchaseWrapper = ({ children }) => {
    const { user_id } = useParams();
    const project_id = localStorage.getItem('pkey');
    /**
     * getApi
     * Fetches user purchase data from the API.
     */
    const getApi = (query) => {
        return getCustomerPurchaseList(query + '&id=' + user_id + '&project_key=' + project_id)
    }
    return <ComponentRequest.Provider value={{ comRequest }}>
        <QueryRequestProvider>
            <QueryResponseProvider getApi={getApi}>
                <ListViewProvider>
                    {children}
                </ListViewProvider>
            </QueryResponseProvider>
        </QueryRequestProvider>
    </ComponentRequest.Provider>
}

export { UserPurchaseWrapper }